import React, { useState } from 'react';
import {
  Icon, Header, Card, Text,
} from 'tabler-react';
import cn from 'classnames';

export function Stamp({
  children,
  className,
  size = 'md',
  color = '',
  icon,
  iconHover,
  colorHover,
  onClick,
}) {
  const [isHover, setHover] = useState(false);
  const iconName = isHover ? iconHover : icon;
  const iconColor = isHover ? colorHover : color;

  const classes = cn(
    { stamp: true, [`stamp-${size}`]: size, [`bg-${iconColor}`]: iconColor },
    className,
    'button-with-highlight',
  );

  return (
    <span onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} onClick={() => onClick && onClick()} className={classes}>
      {iconName && <Icon className="text-white" name={iconName} />}
      {children}
    </span>
  );
}


export function StampCard({
  children,
  className,
  icon,
  iconHover,
  color = '',
  colorHover,
  header,
  footer,
  onClick,
  onStampClick,
}) {
  return (
    <Card className="p-3 card-hover">
      <div onClick={(...args) => onClick && onClick(...args)} className="d-flex align-items-center ">
        <Stamp colorHover={colorHover} iconHover={iconHover} onClick={onStampClick} color={color} icon={icon} className="mr-3" />
        <div>
          {header && (
            <Header size={4} className="m-0">
              {header}
            </Header>
          )}
          {children}
          {footer && <Text.Small muted>{footer}</Text.Small>}
        </div>
      </div>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/archive/component.js